<template>
  <div :class="[{cursor_load:state_load},'picture']">
    <div class="nav clearfix navResize">
      <ul class="options clearfix">
        <li :class="{ active: active_nav_idx == 0 }" @click="activeFn(0, '图片')">图片</li>
        <li :class="{ active: active_nav_idx == 1 }" @click="activeFn(1, '表情')">表情</li>
        <li :class="{ active: active_nav_idx == 2 }" @click="activeFn(2, '图标')">图标</li>
        <!-- <li :class="{ active: active_nav_idx == 3 }"
            @click="activeFn(3, '动图')">
          动图
        </li>-->
      </ul>
      <div class="keyWords" v-show="Keys[key_idx].length!=0">
        <span
          v-for="(val, idx) in Keys[key_idx]"
          :key="idx"
          :class="{cursor_load:state_load, active: active_keys_idx == idx }"
          @click="active_key_fn(idx, val)"
        >{{ val }}</span>
      </div>
    </div>
    <div class="prompt" v-show="prompt_show">{{ prompt_value }}</div>
    <div class="list_box resultResize">
      <vue-waterfall-easy
        :class="{cursor_load:state_load}"
        :imgsArr="itemSet"
        :gap="gapW"
        :imgWidth="imgW"
        :width="waterfallW"
        :maxCols="10"
        ref="waterfall"
        @click="msg_click"
        @scrollReachBottom="loadMore"
      >
        <div slot="loading"></div>
        <div class="over_moudle" slot="waterfall-over">
          <div>已经到底了：）！</div>
          <div v-show="active_nav_idx == 0" class="other">
            <input type="text" class="searchBox" :placeholder="placeholder">
            <!-- @keyup.enter="submitFn"
            v-model="search_value"-->
            <i class="cus-icon icon14" @click="goSearchFn"></i>
          </div>
        </div>
      </vue-waterfall-easy>
      <div v-show="nav_load" class="nav_load">
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from "../result.js";
import vueWaterfallEasy from "./vue-waterfall-easy/vue-waterfall-easy.vue";
export default {
  name: "comPicture",
  data() {
    return {
      params_m: ["m=image&", "m=face&", "m=icon&", "m=soogif&"],
      params: {
        url: `material.php?m=image&`,
        url_: "material.php?",
        tag: "",
        page: 0
      },
      nav_load: 1,
      timeout: null,
      gapW: 15,
      imgW: 170,
      state_load: 0,
      waterfallW: 385,
      busy: false,
      parans_tag: "图片",
      list_content_class: "img_content",
      search_value: "",
      placeholder: "",
      prompt_value: "搜索 “元宵节” 的结果：",
      prompt_show: false,
      active_nav_idx: 0,
      key_idx: 0,
      active_keys_idx: 0,
      judge_keyExecute: false,
      show_load: "visibility:visible",
      Keys: [
        [
          "全部",
          "酒饮",
          "母婴",
          "汽车",
          "生活",
          "数码",
          "背景",
          "风景",
          "工业",
          "购物",
          "古典",
          "美容",
          "动物",
          "互联网",
          "健康",
          "建筑",
          "交通",
          "教育",
          "节日",
          "科技",
          "美食",
          "旅游",
          "人物",
          "金融",
          "时尚",
          "体育",
          "玩具",
          "植物"
        ],
        [],
        [
          "全部",
          "功能",
          "网站",
          "网络",
          "购物",
          "节日",
          "品牌",
          "媒体",
          "手机主题",
          "人物",
          "食品",
          "金融",
          "交通",
          "表情",
          "数字"
        ],
        [
          "全部",
          "功能",
          "交通",
          "节日",
          "金融",
          "媒体",
          "品牌",
          "人物",
          "食物",
          "手机主题",
          "数字",
          "网络",
          "网站"
        ]
      ],
      longData: [35, 50, 80],
      itemSet: []
    };
  },
  components: {
    vueWaterfallEasy
  },
  methods: {
    //切换nav
    activeFn(idx, tag) {
      this.active_nav_idx = idx;
      switch (idx) {
        case 0:
          this.setWaterfall(15, 170);
          this.list_content_class = "img_content";
          break;
        case 1:
          this.setWaterfall(21, 100);
          this.list_content_class = "emoticon_content";
          break;
        case 2:
          this.setWaterfall(37, 50);
          this.imgW = 50;
          this.list_content_class = "icon_content";
          break;
        default:
          this.list_content_class = "";
          break;
      }
      this.key_idx = idx;
      this.params.page = 1;
      this.parans_tag = tag;
      this.params.tag = "";
      this.search_value = "";
      this.active_keys_idx = 0;
      this.params.url = `${this.params.url_}${this.params_m[idx]}`;
      this.changData();
    },
    //设置瀑布流
    setWaterfall(gapW, imgW) {
      this.gapW = gapW;
      this.imgW = imgW;
    },
    //切换key
    active_key_fn(idx, tag) {
      if (this.judge_keyExecute) return;
      this.active_keys_idx = idx;
      this.search_value = "";
      this.params.page = 1;
      this.params.tag = tag;
      this.parans_tag = tag;
      this.changData();
    },
    //切换数据，数据节流加载
    changData() {
      this.nav_load = 1;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.state_load = 1;
        this.judge_keyExecute = true;
        document.querySelector(".list_box").scrollTop = 0;
        this.getData();
      }, 500);
    },
    //瀑布流item点击
    msg_click(event, { index, value }) {
      this.$emit("add_ueditor_value", this.itemSet[index]);
    },
    //获取数据
    getData(type) {
      this.prompt_show = false;
      return getInfo(this.params)
        .then(res => {
          if (res.data && res.data.length != 0) {
            if (type) {
              this.itemSet = this.itemSet.concat(res.data);
            } else {
              this.itemSet = res.data;
            }

            // this.prompt_value = `搜索 “${
            // 	this.search_value
            // }” 的结果：`;
          } else if (this.params.page == 1) {
            this.prompt_show = true;
            this.itemSet = [];
            this.prompt_value = `很抱歉，没有找到 “${this.params.tag ||
              this.parans_tag}” 相关的结果：`;
          }
          if (!res.data) {
            this.placeholder = `搜索更多 ${this.params.tag ||
              this.parans_tag} 素材`;
            this.$refs.waterfall.waterfallOver();
          } else {
            this.busy = false;
          }

          setTimeout(() => {
            this.state_load = 0;
            this.show_load = "visibility:hidden";
            this.nav_load = 0;
            this.judge_keyExecute = false;
          }, 1000);
        })
        .then(res => {});
    },
    //站外跳转搜索
    goSearchFn() {
      window.open(
        `https://pixabay.com/zh/images/search/${this.params.tag ||
          this.parans_tag}/`
      );
    },
    //下拉加载
    loadMore() {
      if (this.busy) return;
      this.show_load = "visibility:visible";
      this.state_load = 1;
      this.busy = true;
      setTimeout(() => {
        this.params.page++;
        this.getData(1);
      }, 300);
    },
    //站内搜索
    submitFn() {
      this.state_load = 1;
      this.params.page = 1;
      this.params.tag = this.search_value;
      this.getData();
    }
  },
  created() {
    this.$on("msg-waterfall385", function() {
      this.waterfallW = 385;
    });
    this.$on("msg-waterfall755", function() {
      this.waterfallW = 755;
    });
    this.$on("msg-waterfallInit", function() {
      this.setWaterfall(this.gapW, this.imgW);
      this.changData();
    });
  }
};
</script>

<style lang="scss">
.picture {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  color: #535353;
  position: relative;
  font-size: 14px;

  .clearfix {
    zoom: 1;
    &::after {
      content: "";
      height: 0;
      line-height: 0;
      display: block;
      visibility: hidden;
      clear: both;
    }
  }

  .options {
    min-width: 385px;
    position: relative;
    width: 100%;
    height: 50px;
    display: flex;
    // justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;

    li {
      cursor: pointer;
      line-height: 48px;
      padding: 0 15px;
      border-bottom: 2px solid transparent;

      &:hover {
        color: $color;
        border-bottom: 2px solid $color;
      }
    }
  }
  .other {
    // float: left;
    // min-width: 385px;
    // width: 100%;
    // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    float: left;
    padding: 10px 22px 10px 10px;
    line-height: 25px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    flex-wrap: wrap;

    i {
      pointer-events: visible;
    }

    .btn {
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding: 0 10px;
      border-radius: 5px;
      line-height: 25px;
      &.active {
        border: 1px solid $color;
        background-color: $color;
        color: #ffffff;
      }
    }
  }
  .keyWords {
    min-width: 385px;
    width: 100%;
    line-height: 27px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px 16px;
    box-sizing: border-box;
    position: relative;

    span {
      margin-right: 20px;
      display: inline-block;
      cursor: pointer;
      &:hover {
        color: $color;
      }
    }
  }
  .active {
    color: $color;
    font-weight: bold;
  }
  .searchBox {
    background-color: #f0f0f0;
    color: #a9aba8;
    font-size: 12px;
    border-radius: 15px;
    line-height: 25px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 30px 0 15px;
    width: 150px;
    border: none;

    &:hover + .icon14 {
      @extend .icon14_;
    }
  }
  .prompt {
    width: 330px;
    margin: auto;
    line-height: 40px;
    font-size: 13px;
    text-align: center;
    margin-top: 15px;
    background-color: rgba(204, 204, 204, 1);
  }

  .list_box {
    width: 100%;
    position: absolute;
    top: 206px;
    bottom: 0;
    overflow: hidden;
  }
  .list_content {
    width: 100%;
    font-size: 13px;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    float: left;
    flex-wrap: wrap;
    min-height: 101%;
    align-content: flex-start;
    &.img_content li {
      width: 170px;
      margin: 7px 0 8px 15px;
    }
    &.icon_content li {
      width: 50px;
      margin: 7px 0 8px 37px;
    }

    li {
      cursor: pointer;
      width: 100px;
      margin: 7px 0 8px 21px;
      background-color: #fff;
      overflow: hidden;
      box-sizing: border-box;

      img {
        width: 100%;
      }
    }
  }

  .title {
    position: relative;
    .dropdown {
      position: absolute;
      left: 0;
      top: 105%;
      display: none;
    }
    &:hover .dropdown {
      display: block;
    }
  }
  .icon14 {
    position: absolute;
    left: 140px;
  }

  .list_content li.load {
    position: relative;
    width: 100%;
    display: flex;
    float: left;
    height: 15px;
    margin: 0;
    justify-content: center;
    .el-icon-loading {
      position: absolute;
    }
  }

  .waterfall {
    width: 100%;
    height: 100%;
    .page {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .content {
      position: fixed;
      top: 100%;
    }
    .content img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-picture.vue